module.exports = __webpack_public_path__ + "static/media/test-blur.5ee5746f.jpg";